import { mapState, mapGetters, mapActions } from 'vuex'
import Loading from '@/components/Core/Loading'
import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'

export default {
  name: 'ServiceRegistDeliveryTypeModal',
  components: {
    Loading
  },
  data () {
    return {
      loading: true,
      processing: false,

      // テーブルオプション
      tableColumns: [
        'checkbox',
        'deliveryTypeMstId',
        'deliveryTypeName',
        'deliveryType',
        'deliveryPriorityKbn',
        'deliveryTypeStatus'
      ],
      tableData: [],
      tableOptions: {
        headings: {
          checkbox: '',
          deliveryTypeMstId: '配信タイプID',
          deliveryTypeName: '配信タイプ名',
          deliveryType: '配信タイプ',
          deliveryPriorityKbn: '優先度',
          deliveryTypeStatus: 'ステータス'
        },
        columnsClasses: {
          checkbox: 'wp-3',
          deliveryTypeMstId: 'wp-5',
          deliveryTypeName: '',
          deliveryType: '',
          deliveryPriorityKbn: '',
          deliveryTypeStatus: ''
        },
        sortable: [
          'deliveryTypeMstId',
          'deliveryTypeName',
          'deliveryType',
          'deliveryPriorityKbn',
          'deliveryTypeStatus'
        ],
        filterable: [],
        texts: Constants.TableOptions.getTexts('配信タイプ'),
        perPage: Constants.TableOptions.perPage.modal,
        perPageValues: Constants.TableOptions.perPageValues,
        pagination: Constants.TableOptions.pagination
      },

      // 絞込み
      activeFilters: false,
      filterPerPage: Constants.TablePerPageInitial,

      // チェックリスト
      checkList: []
    }
  },
  mounted () {
    this.init()
  },
  computed: {
    ...mapState({
      active: state => state.serviceRegistDeliveryTypeModal.active,

      // model
      deliveryTypeMstModel: state => state.serviceRegistDeliveryTypeModal.deliveryTypeMstModel,

      // form
      serviceId: state => state.serviceRegistDeliveryTypeModal.serviceId,
      deliveryTypeModel: state => state.serviceDeliveryTerm.deliveryTypeModel,

      // confirm
      confirmKey: state => state.confirm.key,
      confirmAccepted: state => state.confirm.accept
    }),
    ...mapGetters({
      isSmartPhone: 'core/isSmartPhone'
    }),

    // list
    tablePerPageList () {
      let list = []
      Constants.TablePerPage.forEach(item => list.push({
        value: item,
        label: item
      }))
      return list
    },
    showFilters () {
      return !this.isSmartPhone ||
        this.activeFilters
    },

    disableConfirmButton () {
      if (!this.checkList.length) return true
      if (this.checkList.length !== this.deliveryTypeModel.length) return false

      // 元データから変更があるか確認
      let flag = true
      this.deliveryTypeModel
        .map(item => item.serviceDeliveryTypeUuid)
        .forEach(item => {
          if (this.checkList.indexOf(item) === -1)
            flag = false
        })
      return flag
    }
  },
  watch: {
    '$route' () {
      // ルーティング変更時にコンポーネントを非表示
      this.hide()
    },
    active (to) {
      if (!to) {
        this.hide()
      }
    },
    confirmAccepted: function (to) {
      // 登録
      if (this.confirmKey === 'select') {
        if (to) this.postData()
      }
    }
  },
  methods: {
    ...mapActions({
      showError: 'error/show',
      showConfirm: 'confirm/show',
      showToast: 'toast/show',
      loadModel: 'serviceRegistDeliveryTypeModal/loadModel',
      hide: 'serviceRegistDeliveryTypeModal/hide',
      setUpdated: 'serviceRegistDeliveryTypeModal/setUpdated'
    }),

    init () {
      this.loading = true

      // データ更新フラグの初期化
      this.setUpdated(false)

      // 選択済み連携CMSのIDをチェックリストに格納
      console.log(this.deliveryTypeModel)
      if (this.deliveryTypeModel &&
        this.deliveryTypeModel.length) {
        this.checkList = $.extend(true, [], this.deliveryTypeModel.map(item => item.deliveryTypeMstUuid))
      }
      console.log(this.checkList)

      //TODO
      let deliveryTypeMstParams = {}

      // データ読出し
      this.loadModel({
        deliveryTypeMstParams: deliveryTypeMstParams
      })
        // eslint-disable-next-line
        .then(res => {
          this.loading = false
          this.tableData = $.extend(true, [], this.deliveryTypeMstModel)
        })
        .catch(error => {
          this.showError(error || null)
        })
    },
    getViewData (props) {
      let key = props.column
      let value = props.row[key]

      switch (key) {
        case 'checkbox':
          return props.row.deliveryTypeMstUuid
        case 'deliveryPriorityKbn':
          return Utility.getConstantsLabel(['Mst', 'DeliveryPriorityKbn'], value)
        case 'deliveryTypeStatus':
          return Utility.getConstantsLabel(['Status'], value)
      }
      return value
    },
    changePage () {
      // console.log(this.$refs.table.page)
    },
    
    toggleFilters () {
      this.activeFilters = !this.activeFilters
    },
    changePerPage () {
      this.$refs.table.setLimit(this.filterPerPage)
    },

    confirmData () {
      this.showConfirm({
        key: 'select',
        title: '配信タイプの選択',
        body: 'この内容で情報を変更しますか？'
      })
    },
    postData () {
      console.log('check : ', this.checkList)

      this.processing = true

      let parameters = {
        serviceUuid: this.serviceId,
        request: {
          deliveryTypeMstUuids: this.checkList
        }
      }
      console.log('register data', parameters)

      // 登録
      ApiManager.request(
        ['serviceDeliveryType'],
        ['v1ServiceDeliveryTypePut'],
        [parameters])
        .then(res => {
          this.processing = false
          let status = Utility.parseResponse(res)

          if (status.result) {
            // toast
            this.showToast({
              title: '配信タイプの登録',
              body: '「配信タイプ」を登録しました。'
            })

            // データ更新フラグを有効
            // 呼び出し元のページで一覧を更新するため
            this.setUpdated(true)

            this.closeModal()

          } else if (status.error) {
            // エラーメッセージ表示
            this.showError(res)
          } else {
            // アプリケーションエラー表示
            this.showError(null)
          }
          
        })
        // eslint-disable-next-line
        .catch(error => {
          this.processing = false
          this.showError(null)
        })
    },
    
    /**
     * モーダルを閉じる
     */
    closeModal () {
      this.hide()
    }
  }
}